import { provideRouteChangeHandler } from '@frontend-site/shared/router-store';
import { SystemDetailsCleanerService } from './system-details-cleaner.service';

export const systemDetailsCleanerServiceProvider = provideRouteChangeHandler(SystemDetailsCleanerService);
